import React from "react"
import { withTheme, useMediaQuery, useTheme } from "@material-ui/core"
import Background from "../background"
import Image from "../image"
import styled from "styled-components"
import ArrowButton from "./arrowButton"
import ProductCards from "../product-cards"
import Container from "../container"
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next"

export default () => {
  const theme = useTheme()
  let { t } = useTranslation()
  const { language } = useI18next()
  const downXs = useMediaQuery(theme.breakpoints.down("xs"))

  return (
    <WaasWrapper>
      <WaasBg
        filename="service-bg.png"
        style={{
          position: "absolute",
          width: "1535px",
          height: "959px",
          objectPosition: "top left",
        }}
      />
      <WaasContainer>
        <h1>Web3.0 as a Service</h1>
        <ProductCards style={{ marginTop: downXs ? "51px" : "62px" }} />

        <FlexContainer style={{ marginTop: downXs ? "38px" : "74px" }}>
          <ItemImage filename="Development.png" objectFit="contain" />
          <ItemDescription>
            <h1>Development</h1>
            {language === "ja" ? <h2>（プロダクト開発）</h2> : []}
            <p>
              {t(
                `We focus on developing and delivering systems for companies that want to implement products and technologies that solve scalability problems in their business. We propose a combination of the latest technologies and existing stable technologies.`,
                { ns: "index" }
              )}
            </p>
            <ArrowButton to="/service#development" />
          </ItemDescription>
        </FlexContainer>

        <FlexContainer flexDirection="row-reverse">
          <ItemImage filename="RD.png" objectFit="contain" />
          <ItemDescription>
            <h1>{"R&D"}</h1>
            {language === "ja" ? <h2>（研究開発）</h2> : []}
            <p>
              {t(
                "Our research area is specialized in decentralized scalability, privacy, and interoperability. Furthermore, to support our research and the community, we are actively developing different types of decentralized protocols.",
                { ns: "index" }
              )}
            </p>
            <ArrowButton to="/service#rd" />
          </ItemDescription>
        </FlexContainer>

        <FlexContainer>
          <ItemImage filename="Consulting.png" objectFit="contain" />
          <ItemDescription>
            <h1>Tech Consulting</h1>
            {language === "ja" ? <h2>（技術コンサルティング）</h2> : []}
            <p>
              {t(
                "We provide technical consulting services and technical support for enterprises that are implementing Web3.0 technology to their organization.",
                { ns: "index" }
              )}
            </p>
            <ArrowButton to="/service#consulting" />
          </ItemDescription>
        </FlexContainer>
      </WaasContainer>
    </WaasWrapper>
  )
}

const WaasContainer = withTheme(
  styled(Container)`
    position: relative;
    z-index: 10;
    padding-top: 120px;
    padding-bottom: 76px;
    letter-spacing: 0px;
    color: #ffffff;
    width: 100%;
    h1 {
      text-align: center;
      margin: 0px auto 0px;
      font: Bold 50px/67px TT Commons;
    }
    ${props => props.theme.breakpoints.down("xs")} {
      padding-top: 75px;
      padding-bottom: 120px;
      h1 {
        font-size: 34px;
        line-height: 46px;
      }
    }
  `
)

const WaasWrapper = styled.div`
  position: relative;
  overflow: hidden;
  background-color: #000000;
`

const WaasBg = styled(Background)`
  background-color: #000000;
`

const FlexContainer = withTheme(
  styled.div(
    props => `
  display: flex;
  min-height: 100px;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props.flexDirection};
  ${props.theme.breakpoints.down("xs")} {
    display: block;
    padding-left: ${props.theme.spacing(2)}px;
    padding-right: ${props.theme.spacing(2)}px;
  }
`
  )
)

const ItemImage = withTheme(
  styled(Image)(
    props => `
  flex: 4 4 0px;
  max-width: 420px;
  ${props.theme.breakpoints.down("xs")} {
    margin: 0 auto 0;
  }
`
  )
)

const ItemDescription = withTheme(
  styled.div(
    props => `
  flex: 5 5 0px;
  max-width: 680px;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-align: left;
  opacity: 1;
  h1 {
    display: inline;
    margin: 0px;
    padding: 0px;
    text-align: inherit;
    font: 38px/52px TT Commons;
    font-weight: 600;
  }
  h2 {
    display: inline-block;
    margin: 0px;
    padding: 0px;
    font-weight: normal;
    font: 700 22px/30px Noto Sans JP;
  }
  p {
    text-align: left;
    margin-top: 25px;
    font: 16px/30px Noto Sans JP;
    color: #B2B2B2;
  }
  ${props.theme.breakpoints.down("xs")} {
    margin-top: -20px;
    h1{
      font-size: 28px;
      line-height: 38px;
    }
    h2{
      font-size: 15px;
    }
    p{
      font-size: 15px;
      margin-top: 16px;
    }
  }
`
  )
)
